<template>
  <div class="firePolice hand-police">
    <div v-if="active == 0 || active == 1">
      <div class="hand-title">
        <span>手报报警调度派单</span>
      </div>
      <div class="hand-h1">报警信息</div>
      <div class="hand-info">
        <div class="hand-text">
          <p>
            <i class="el-icon-time"></i>
            <span>{{ alarmTime }}</span>
          </p>
          <p>
            <i class="el-icon-location-outline"></i>
            <span>{{ disasterAddress }}</span>
          </p>
        </div>
      </div>
    </div>
    <div class="hand-footer">
      <el-button type="primary">启动消防警报</el-button>
      <el-button type="primary" @click="handleVideoStatus" v-if="isEquipment">{{ videoName === 1 ? '查看视频' : '关闭视频' }}</el-button>
      <el-button type="primary" :class="isMikeButton?'':'buttonMike'" @click="openMike" v-if="isEquipment">开启声音</el-button>
      <el-button type="primary" @click="misinformation()">设备误报</el-button>
      <el-button type="primary" @click="atOnceCall" v-if="active == 0">出警派单</el-button>
    </div>
    <el-dialog
      :visible.sync="dialog.pinkAlarmDialog"
      width="939px"
      title="手报报警"
      append-to-body
      style="margin-top:-8vh;"
      center
      class="endNoticeDialog">
      <firePink :alarmId="alarmId" :q="q" @closePinkAlarmDialog="closePinkAlarmDialog" ref="firePink"></firePink>
    </el-dialog>
    <el-dialog
      :visible.sync="errReportDialog"
      title="设备误报"
      custom-class="q-report sbwb">
      <el-form ref="errForm" label-width="100px">
        <el-form-item label="误报内容">
          <el-input type="textarea" v-model="errForm.content" :rows="5"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleReport">提交</el-button>
          <el-button @click="errReportDialog = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import fireBook from '@/pages/fireBook/fireBook'
import firePink from '@/pages/fireBook/firePink'
import {begin} from '@/js/mike'
import {end} from '@/js/mike'

export default {
  name: 'handAlarm',
  components: {
    fireBook,
    firePink
  },
  props: ['alarmId'],
  data() {
    return {
      videoName: 1,
      player: '',
      disasterAddress: '',
      alarmTime: '',
      errForm: {
        content: ''
      },
      butt: false,
      active: 0,
      cjPersons: [],
      selectCjPersons: [],
      isMikeButton:false,
      equs: [],
      selectEqus: [],
      selectRow: {id: this.alarmId},
      errReportDialog: false,
      dialog: {
        visible: false,
        phoneVisible: false,
        bb: false
      },
      content: '',
      fullscreen: true,
      dialog: {
        pinkAlarmDialog: false
      },
      msgUrl: "",
      q: {
        id: '',
        msgDetail: '',
        smokeName: '烟感报警',
        pinkName: '火眼报警'
      },
      title: {
        title1: '接警',
        title2: '调度派单',
      },
      tip: '立即报警',
      showDispatchOrder: true,
      idStr: '',
      isEquipment:false,
    }
  },
  mounted() {
    this.handleSearch();
  },
  methods: {
    openMike(){
      let _this = this;
       _this.isMikeButton = !_this.isMikeButton;
      _this.http.post('/webapi/probeEquipment/queryCamera', {id:_this.alarmId}, function(data){
         if(_this.isMikeButton){
           begin(data.cvrDevice,data.cvrChannel)
         }else{
           end()
         }
      });
    },
    handleVideoStatus() {
      if (this.videoName === 1) {
        this.videoName = 0
        this.$emit('isVideo', false)
      } else {
        this.videoName = 1
        this.$emit('isVideo', true)
      }
    },
    auditInfo() {
      let _this = this;
      if (!_this.content) {
        _this.$message.warning("请输入审核内容");
        return;
      }
      var data = {
        content: _this.content,
        id: _this.alarmId
      }
      var success = function (resp) {
        if (resp.code === '0') {
          _this.dialog.handAlarmVisible = false;
          _this.errReportDialog = false;
        }
      }
      _this.http.post('/webapi/writ/submitAudit', data, success);
    },
    queryFireBook() {//查询火场文书
      let _this = this;
      var success = function (resp) {
        _this.selectRow = resp;
        _this.selectRow.audit = '1';
        _this.selectRow.idStr = _this.idStr;
        _this.active = _this.active + 1;
      }
      _this.http.get('/webapi/alarmManual/' + _this.alarmId, {}, success);
    },
    handleReport() {
      let _this = this;
      let param = {
        content: this.errForm.content,
        id: _this.alarmId
      }
      let success = function (resp) {
        if (resp.code === "0") {
          _this.errReportDialog = false
          // _this.$emit("isHandAlarmVisible");
          _this.$message.success("提交成功");
          _this.$root.eventHub.$emit('stopBellRing')
        }
      }
      _this.http.post('/webapi/writ/yesMisdeclaration', param, success);
    },
    jumpVideo() {
      let _this = this;
      _this.butt = !_this.butt;
      var videoObject = {
        container: '#video', //容器的ID或className
        variable: 'player', //播放函数名称
        loop: false, //播放结束是否循环播放
        // poster: 'material/poster.jpg', //封面图片
        // preview: { //预览图片
        //     file: ['material/mydream_en1800_1010_01.png', 'material/mydream_en1800_1010_02.png'],
        //     scale: 2
        // },
        autoplay: true,
        flashplayer: true, //强制使用flashplayer播放
        live: false,
        // debug:true,
        // cktrack: 'material/zh.vtt',
        video: [
          [_this.msgUrl, 'video/m3u8', '中文标清', 0],
        ]
      };
      var player = new ckplayer(videoObject);
    },
    callbackfun(e) {
    },
    closePinkAlarmDialog() {
      _this.dialog.pinkAlarmDialog = false;
    },
    iconClose() {//关闭视频
      _this.butt = false;
    },
    dispatchOrder() {
      let _this = this;
      if (_this.selectCjPersons.length <= 0) {
        _this.$message.warning("请选择出警人员")
        return;
      }
      if (_this.selectEqus.length <= 0) {
        _this.$message.warning("请选择装备")
        return;
      }
      var alarmCommanderIds = _this.selectCjPersons.map(item => {
        return item.id;
      });
      var equipmentIds = _this.selectEqus.map(item => {
        return item.id;
      });
      var data = {
        id: _this.alarmId,
        alarmCommanderIds: alarmCommanderIds.join(),
        equipmentIds: equipmentIds.join()
      }
      var success = function (resp) {
        if (resp.code === '0') {
          _this.queryFireBook();
        }
      }
      _this.http.post('/webapi/writ/goPoliceAdd', data, success);
    },
    atOnceCall() {
      let _this = this;
      _this.videoName = 1; 
      _this.butt = false;
      end();
      _this.$emit("isHandAlarmVisible");
    },
    misinformation() {
      let _this = this;
      _this.errReportDialog = true
    },
    handleSearch() {
      let _this = this;
      var success = function (resp) {
        _this.disasterAddress = [];
        _this.alarmTime = [];
        _this.cjPersons = [];
        _this.equs = [];
        _this.msgUrl = [];
        _this.disasterAddress = resp.alarmSingleDO.disasterAddress;
        _this.alarmTime = resp.alarmSingleDO.alarmTime;
        _this.cjPersons = resp.userDOList;
        _this.equs = resp.equipment;
        _this.msgUrl = resp.url;
        if(resp.isEquipment==0){
          _this.isEquipment=false
        }else{
          _this.isEquipment=true
        }
      }
      _this.http.get('/webapi/writ/isMisdeclaration/' + _this.alarmId, {}, success);
    }
  }
}
</script>
<style lang="less">

.el-dialog__wrapper{
  .sbwb{
    width:400px;
    .el-dialog__header{
      padding:20px
    }
    .el-dialog__body{
      padding:0px 20px 30px 20px;
    }
  }
}

.reportPolice {
  cursor: pointer;
}

.hand-police {
  .buttonMike{
    background: #717777;
  }
  .hand-title {
    height: 57px;
    background: #0080DB;
    border-radius: 18px 18px 0px 0px;
    text-align: center;
    line-height: 57px;

    span {
      height: 24px;
      font-size: 24px;
      color: #FFFFFF;
    }
  }

  .hand-h1 {
    height: 18px;
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #333333;
    text-align: center;
    line-height: 25px;
    padding: 20px 0px;
  }

  .hand-info {
    padding: 0px 20px 30px;

    .hand-text {
      background: #C8E8FF;
      padding: 20px;
      border-radius: 8px;

      p {
        padding: 10px 20px;
      }

      span {
        height: 18px;
        font-size: 18px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #333333;
        line-height: 25px;
      }

      i {
        color: #0080DB;
        font-size: 24px;
      }
    }

    .info-img {
      position: relative;

      #Player {
        position: absolute !important;
      }
    }
  }

  .hand-footer {
    text-align: center;
    padding: 0px 0px 30px;

    .el-button {
      font-size: 16px;
      color: #FFFFFF;
      margin: 0px 10px
    }
  }
}

.endNoticeDialog {
  .probeFun {
    width: 942px;
    margin: auto;
    border: 1px solid #EBEEF5;
    border-radius: 10px;
  }

  .proImg {
    overflow: hidden;

    .el-checkbox {
      line-height: 42px;
    }
  }

  .proImgImg {
    float: left;
    width: 29%;
    margin: 5px 16px 0 16px;

    .proPicVid {
      position: relative;

      .el-icon-circle-close:before {
        color: #fff;
      }
    }

    .proBot {
      width: 200px;
      color: #fff;
      text-align: center;
      background: #3B3B3B;
      opacity: .7;
      position: absolute;
      left: 0;
      bottom: 0;
    }
  }
}

.firePolice .hand-police {
  .endNoticeDialog {
    .el-dialog {
      background: #ffffff;
      border-radius: 18px;

      .el-dialog__header {
        background: #0080DB;

        .el-dialog__title {
          color: white;
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/handAlarm.vue